import { ErrorCode } from '../models';

export const REFERENCE_TYPES = Object.freeze([
  { displayName: 'Corporate Information', value: 'CorporateInfo', id: 1, typeName: 'CORPORATE INFORMATION' },
  { displayName: "Director's Guide", value: 'DirectorsGuide', id: 2, typeName: "DIRECTOR'S GUIDE" },
  {
    displayName: 'General Board Information',
    value: 'GeneralBoardInfo',
    id: 3,
    typeName: 'GENERAL BOARD INFORMATION'
  }
]);
export const EVALUATION_QUESTIONS_TYPE = {
  text: 'Text',
  textArea: 'Note',
  boolean: 'Boolean',
  dateTimePicker: 'DateTime',
  checkbox: 'Choice',
  number: 'Number',
  opinion: 'Opinion',
  radio: 'Radio',
  combo: 'Combo',
  textSingleLine: 'TextSingleLine',
  textMultiLine: 'TextMultiLine',
  date: 'Date'
};

export const ROLES = {
  administrators: 'Administrators',
  directors: 'Directors',
  auditors: 'Auditors',
  committeeAdmins: 'CommitteeAdministrators',
  officers: 'Officers',
  regulators: 'Regulators',
  seniorOfficers: 'SeniorOfficers',
  siteViewers: 'SiteViewers',
  techAdmins: 'TechnicalAdministrators',
  userAdmins: 'UserAdministrators',
  documentAdmins: 'DocumentAdministrators',
  committeeManagers: 'CommitteeManagers'
};

export const BROWSER_RESTRICTED_ROLES: string[] = ['Auditors', 'Directors', 'Officers', 'Regulators', 'Senior Officers', 'Site Viewers'];

export const AREAS = Object.freeze([
  // { displayName: "All", value: "all", id: 0 },
  { displayName: 'Alerts', value: 'alerts', id: 1 },
  { displayName: 'Collaboration', value: 'collaboration', id: 13 },
  { displayName: 'Corporate Information', value: 'corporateInfo', id: 4 },
  { displayName: "Director's Guide", value: 'directorsGuide', id: 5 },
  { displayName: 'Discussions', value: 'discussions', id: 8 },
  { displayName: 'Evaluations', value: 'evaluations', id: 17 },
  { displayName: 'General Board Information', value: 'generalBoardInfo', id: 6 },
  { displayName: 'Links', value: 'links', id: 9 },
  { displayName: 'Meetings & Events', value: 'meetingsEvents', id: 7 },
  { displayName: 'Profiles', value: 'profiles', id: 12 },
  { displayName: 'Surveys', value: 'surveys', id: 10 },
  { displayName: 'Votings', value: 'votings', id: 11 }
]);

export const TIMEZONES = Object.freeze([
  { timeZoneName: 'Pacific/Niue', timeZoneCode: '', displayName: '(UTC-12:00) International Date Line West', id: 'Dateline Standard Time' }, //
  { timeZoneName: 'Pacific/Niue', timeZoneCode: '', displayName: '(UTC-11:00) Coordinated Universal Time-11', id: 'UTC-11' },
  { timeZoneName: 'America/Adak', timeZoneCode: '', displayName: '(UTC-10:00) Aleutian Islands', id: 'Aleutian Standard Time' },
  { timeZoneName: 'America/Adak', timeZoneCode: '', displayName: '(UTC-10:00) Hawaii', id: 'Hawaiian Standard Time' },
  { timeZoneName: 'Pacific/Marquesas', timeZoneCode: '', displayName: '(UTC-09:30) Marquesas Islands', id: 'Marquesas Standard Time' },
  { timeZoneName: 'America/Anchorage', timeZoneCode: '', displayName: '(UTC-09:00) Alaska', id: 'Alaskan Standard Time' },
  { timeZoneName: 'America/Anchorage', timeZoneCode: '', displayName: '(UTC-09:00) Coordinated Universal Time-09', id: 'UTC-09' },
  { timeZoneName: 'America/Santa_Isabel', timeZoneCode: '', displayName: '(UTC-08:00) Baja California', id: 'Pacific Standard Time (Mexico)' },
  { timeZoneName: 'America/Los_Angeles', timeZoneCode: '', displayName: '(UTC-08:00) Coordinated Universal Time-08', id: 'UTC-08' },
  { timeZoneName: 'America/Los_Angeles', timeZoneCode: '', displayName: '(UTC-08:00) Pacific Time (US & Canada)', id: 'Pacific Standard Time' },
  { timeZoneName: 'America/Arizona', timeZoneCode: '', displayName: '(UTC-07:00) Arizona', id: 'US Mountain Standard Time' },
  { timeZoneName: 'America/Chihuahua', timeZoneCode: '', displayName: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', id: 'Mountain Standard Time (Mexico)' },
  { timeZoneName: 'America/Denver', timeZoneCode: '', displayName: '(UTC-07:00) Mountain Time (US & Canada)', id: 'Mountain Standard Time' },
  { timeZoneName: 'America/Whitehorse', timeZoneCode: '', displayName: '(UTC-07:00) Yukon', id: 'Yukon Standard Time' },
  { timeZoneName: 'America/Toronto', timeZoneCode: '', displayName: '(UTC-06:00) Central America', id: 'Central America Standard Time' },
  { timeZoneName: 'America/Mexico_City', timeZoneCode: '', displayName: '(UTC-06:00) Central Time (US & Canada)', id: 'Central Standard Time' },
  { timeZoneName: 'Pacific/Easter', timeZoneCode: '', displayName: '(UTC-06:00) Easter Island', id: 'Easter Island Standard Time' },
  { timeZoneName: 'America/Mexico_City', timeZoneCode: '', displayName: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', id: 'Central Standard Time (Mexico)' },
  { timeZoneName: 'America/Mexico_City', timeZoneCode: '', displayName: '(UTC-06:00) Saskatchewan', id: 'Canada Central Standard Time' },
  { timeZoneName: 'America/Lima', timeZoneCode: '', displayName: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', id: 'SA Pacific Standard Time' },
  { timeZoneName: 'America/Cancun', timeZoneCode: '', displayName: '(UTC-05:00) Chetumal', id: 'Eastern Standard Time (Mexico)' },
  { timeZoneName: 'America/Cancun', timeZoneCode: '', displayName: '(UTC-05:00) Eastern Time (US & Canada)', id: 'Eastern Standard Time' },
  { timeZoneName: 'America/Port-au-Prince', timeZoneCode: '', displayName: '(UTC-05:00) Haiti', id: 'Haiti Standard Time' },
  { timeZoneName: 'America/Havana', timeZoneCode: '', displayName: '(UTC-05:00) Havana', id: 'Cuba Standard Time' },
  { timeZoneName: 'America/Indiana/Indianapolis', timeZoneCode: '', displayName: '(UTC-05:00) Indiana (East)', id: 'US Eastern Standard Time' },
  { timeZoneName: 'America/Grand_Turk', timeZoneCode: '', displayName: '(UTC-05:00) Turks and Caicos', id: 'Turks And Caicos Standard Time' },
  { timeZoneName: 'America/Asuncion', timeZoneCode: '', displayName: '(UTC-04:00) Asuncion', id: 'Paraguay Standard Time' },
  { timeZoneName: 'America/Anguilla', timeZoneCode: '', displayName: '(UTC-04:00) Atlantic Time (Canada)', id: 'Atlantic Standard Time' },
  { timeZoneName: 'America/Caracas', timeZoneCode: '', displayName: '(UTC-04:00) Caracas', id: 'Venezuela Standard Time' },
  { timeZoneName: 'America/Cuiaba', timeZoneCode: '', displayName: '(UTC-04:00) Cuiaba', id: 'Central Brazilian Standard Time' },
  { timeZoneName: 'America/Manaus', timeZoneCode: '', displayName: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', id: 'SA Western Standard Time' },
  { timeZoneName: 'America/Santiago', timeZoneCode: '', displayName: '(UTC-04:00) Santiago', id: 'Pacific SA Standard Time' },
  { timeZoneName: 'America/St_Johns', timeZoneCode: '', displayName: '(UTC-03:30) Newfoundland', id: 'Newfoundland Standard Time' },
  { timeZoneName: 'America/Araguaina', timeZoneCode: '', displayName: '(UTC-03:00) Araguaina', id: 'Tocantins Standard Time' },
  { timeZoneName: 'America/Araguaina', timeZoneCode: '', displayName: '(UTC-03:00) Brasilia', id: 'E. South America Standard Time' },
  { timeZoneName: 'America/Cayenne', timeZoneCode: '', displayName: '(UTC-03:00) Cayenne, Fortaleza', id: 'SA Eastern Standard Time' },
  { timeZoneName: 'America/Argentina/Buenos_Aires', timeZoneCode: '', displayName: '(UTC-03:00) City of Buenos Aires', id: 'Argentina Standard Time' },
  { timeZoneName: 'America/Godthab', timeZoneCode: '', displayName: '(UTC-03:00) Greenland', id: 'Greenland Standard Time' },
  { timeZoneName: 'America/Montevideo', timeZoneCode: '', displayName: '(UTC-03:00) Montevideo', id: 'Montevideo Standard Time' },
  { timeZoneName: 'America/Punta_Arenas', timeZoneCode: '', displayName: '(UTC-03:00) Punta Arenas', id: 'Magallanes Standard Time' },
  { timeZoneName: 'America/Miquelon', timeZoneCode: '', displayName: '(UTC-03:00) Saint Pierre and Miquelon', id: 'Saint Pierre Standard Time' },
  { timeZoneName: 'America/Bahia', timeZoneCode: '', displayName: '(UTC-03:00) Salvador', id: 'Bahia Standard Time' },
  { timeZoneName: 'Atlantic/South_Georgia', timeZoneCode: '', displayName: '(UTC-02:00) Coordinated Universal Time-02', id: 'UTC-02' },
  { timeZoneName: 'Atlantic/South_Georgia', timeZoneCode: '', displayName: '(UTC-02:00) Mid-Atlantic - Old', id: 'Mid-Atlantic Standard Time' },
  { timeZoneName: 'Atlantic/Azores', timeZoneCode: '', displayName: '(UTC-01:00) Azores', id: 'Azores Standard Time' },
  { timeZoneName: 'Atlantic/Cape_Verde', timeZoneCode: '', displayName: '(UTC-01:00) Cabo Verde Is.', id: 'Cape Verde Standard Time' },
  { timeZoneName: 'Europe/London', timeZoneCode: '', displayName: '(UTC) Coordinated Universal Time', id: 'UTC' },
  { timeZoneName: 'Europe/London', timeZoneCode: '', displayName: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', id: 'GMT Standard Time' },
  { timeZoneName: 'Africa/Monrovia', timeZoneCode: '', displayName: '(UTC+00:00) Monrovia, Reykjavik', id: 'Greenwich Standard Time' },
  { timeZoneName: 'Africa/Sao_Tome', timeZoneCode: '', displayName: '(UTC+00:00) Sao Tome', id: 'Sao Tome Standard Time' },
  { timeZoneName: 'Africa/Casablanca', timeZoneCode: '', displayName: '(UTC+01:00) Casablanca', id: 'Morocco Standard Time' },
  { timeZoneName: 'Europe/Amsterdam', timeZoneCode: '', displayName: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', id: 'W. Europe Standard Time' },
  { timeZoneName: 'Europe/Belgrade', timeZoneCode: '', displayName: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', id: 'Central Europe Standard Time' },
  { timeZoneName: 'Europe/Paris', timeZoneCode: '', displayName: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', id: 'Romance Standard Time' },
  { timeZoneName: 'Europe/Sarajevo', timeZoneCode: '', displayName: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', id: 'Central European Standard Time' },
  { timeZoneName: 'Africa/Bangui', timeZoneCode: '', displayName: '(UTC+01:00) West Central Africa', id: 'W. Central Africa Standard Time' },
  { timeZoneName: 'Asia/Amman', timeZoneCode: '', displayName: '(UTC+02:00) Amman', id: 'Jordan Standard Time' },
  { timeZoneName: 'Europe/Athens', timeZoneCode: '', displayName: '(UTC+02:00) Athens, Bucharest', id: 'GTB Standard Time' },
  { timeZoneName: 'Asia/Beirut', timeZoneCode: '', displayName: '(UTC+02:00) Beirut', id: 'Middle East Standard Time' },
  { timeZoneName: 'Africa/Cairo', timeZoneCode: '', displayName: '(UTC+02:00) Cairo', id: 'Egypt Standard Time' },
  { timeZoneName: 'Europe/Chisinau', timeZoneCode: '', displayName: '(UTC+02:00) Chisinau', id: 'E. Europe Standard Time' },
  { timeZoneName: 'Asia/Damascus', timeZoneCode: '', displayName: '(UTC+02:00) Damascus', id: 'Syria Standard Time' },
  { timeZoneName: 'Asia/Gaza', timeZoneCode: '', displayName: '(UTC+02:00) Gaza, Hebron', id: 'West Bank Standard Time' },
  { timeZoneName: 'Harare', timeZoneCode: '', displayName: '(UTC+02:00) Harare, Pretoria', id: 'South Africa Standard Time' },
  { timeZoneName: 'Europe/Helsinki', timeZoneCode: '', displayName: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', id: 'FLE Standard Time' },
  { timeZoneName: 'Asia/Jerusalem', timeZoneCode: '', displayName: '(UTC+02:00) Jerusalem', id: 'Israel Standard Time' },
  { timeZoneName: 'Africa/Juba', timeZoneCode: '', displayName: '(UTC+02:00) Juba', id: 'South Sudan Standard Time' },
  { timeZoneName: 'Europe/Kaliningrad', timeZoneCode: '', displayName: '(UTC+02:00) Kaliningrad', id: 'Kaliningrad Standard Time' },
  { timeZoneName: 'Africa/Khartoum', timeZoneCode: '', displayName: '(UTC+02:00) Khartoum', id: 'Sudan Standard Time' },
  { timeZoneName: 'Africa/Tripoli', timeZoneCode: '', displayName: '(UTC+02:00) Tripoli', id: 'Libya Standard Time' },
  { timeZoneName: 'Africa/Windhoek', timeZoneCode: '', displayName: '(UTC+02:00) Windhoek', id: 'Namibia Standard Time' },
  { timeZoneName: 'Asia/Baghdad', timeZoneCode: '', displayName: '(UTC+03:00) Baghdad', id: 'Arabic Standard Time' },
  { timeZoneName: 'Europe/Istanbul', timeZoneCode: '', displayName: '(UTC+03:00) Istanbul', id: 'Turkey Standard Time' },
  { timeZoneName: 'Asia/Kuwait', timeZoneCode: '', displayName: '(UTC+03:00) Kuwait, Riyadh', id: 'Arab Standard Time' },
  { timeZoneName: 'Europe/Minsk', timeZoneCode: '', displayName: '(UTC+03:00) Minsk', id: 'Belarus Standard Time' },
  { timeZoneName: 'Europe/Moscow', timeZoneCode: '', displayName: '(UTC+03:00) Moscow, St. Petersburg', id: 'Russian Standard Time' },
  { timeZoneName: 'Africa/Nairobi', timeZoneCode: '', displayName: '(UTC+03:00) Nairobi', id: 'E. Africa Standard Time' },
  { timeZoneName: 'Europe/Volgograd', timeZoneCode: '', displayName: '(UTC+03:00) Volgograd', id: 'Volgograd Standard Time' },
  { timeZoneName: 'Asia/Tehran', timeZoneCode: '', displayName: '(UTC+03:30) Tehran', id: 'Iran Standard Time' },
  { timeZoneName: 'Asia/Muscat', timeZoneCode: '', displayName: '(UTC+04:00) Abu Dhabi, Muscat', id: 'Arabian Standard Time' },
  { timeZoneName: 'Europe/Astrakhan', timeZoneCode: '', displayName: '(UTC+04:00) Astrakhan, Ulyanovsk', id: 'Astrakhan Standard Time' },
  { timeZoneName: 'Asia/Baku', timeZoneCode: '', displayName: '(UTC+04:00) Baku', id: 'Azerbaijan Standard Time' },
  { timeZoneName: 'Europe/Samara', timeZoneCode: '', displayName: '(UTC+04:00) Izhevsk, Samara', id: 'Russia Time Zone 3' },
  { timeZoneName: 'Indian/Mauritius', timeZoneCode: '', displayName: '(UTC+04:00) Port Louis', id: 'Mauritius Standard Time' },
  { timeZoneName: 'Europe/Saratov', timeZoneCode: '', displayName: '(UTC+04:00) Saratov', id: 'Saratov Standard Time' },
  { timeZoneName: 'Asia/Tbilisi', timeZoneCode: '', displayName: '(UTC+04:00) Tbilisi', id: 'Georgian Standard Time' },
  { timeZoneName: 'Asia/Yerevan', timeZoneCode: '', displayName: '(UTC+04:00) Yerevan', id: 'Caucasus Standard Time' },
  { timeZoneName: 'Asia/Kabul', timeZoneCode: '', displayName: '(UTC+04:30) Kabul', id: 'Afghanistan Standard Time' },
  { timeZoneName: 'Asia/Ashgabat', timeZoneCode: '', displayName: '(UTC+05:00) Ashgabat, Tashkent', id: 'West Asia Standard Time' },
  { timeZoneName: 'Asia/Yekaterinburg', timeZoneCode: '', displayName: '(UTC+05:00) Ekaterinburg', id: 'Ekaterinburg Standard Time' },
  { timeZoneName: 'Asia/Karachi', timeZoneCode: '', displayName: '(UTC+05:00) Islamabad, Karachi', id: 'Pakistan Standard Time' },
  { timeZoneName: 'Asia/Qyzylorda', timeZoneCode: '', displayName: '(UTC+05:00) Qyzylorda', id: 'Qyzylorda Standard Time' },
  { timeZoneName: 'Asia/Kolkata', timeZoneCode: '', displayName: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', id: 'India Standard Time' },
  { timeZoneName: 'Asia/Colombo', timeZoneCode: '', displayName: '(UTC+05:30) Sri Jayawardenepura', id: 'Sri Lanka Standard Time' },
  { timeZoneName: 'Asia/Kathmandu', timeZoneCode: '', displayName: '(UTC+05:45) Kathmandu', id: 'Nepal Standard Time' },
  { timeZoneName: 'Asia/Dhaka', timeZoneCode: '', displayName: '(UTC+06:00) Astana', id: 'Central Asia Standard Time' },
  { timeZoneName: 'Asia/Dhaka', timeZoneCode: '', displayName: '(UTC+06:00) Dhaka', id: 'Bangladesh Standard Time' },
  { timeZoneName: 'Asia/Omsk', timeZoneCode: '', displayName: '(UTC+06:00) Omsk', id: 'Omsk Standard Time' },
  { timeZoneName: 'Asia/Rangoon', timeZoneCode: '', displayName: '(UTC+06:30) Yangon (Rangoon)', id: 'Myanmar Standard Time' },
  { timeZoneName: 'Asia/Bangkok', timeZoneCode: '', displayName: '(UTC+07:00) Bangkok, Hanoi, Jakarta', id: 'SE Asia Standard Time' },
  { timeZoneName: 'Asia/Barnaul', timeZoneCode: '', displayName: '(UTC+07:00) Barnaul, Gorno-Altaysk', id: 'Altai Standard Time' },
  { timeZoneName: 'Asia/Hovd', timeZoneCode: '', displayName: '(UTC+07:00) Hovd', id: 'W. Mongolia Standard Time' },
  { timeZoneName: 'Asia/Krasnoyarsk', timeZoneCode: '', displayName: '(UTC+07:00) Krasnoyarsk', id: 'North Asia Standard Time' },
  { timeZoneName: 'Asia/Novosibirsk', timeZoneCode: '', displayName: '(UTC+07:00) Novosibirsk', id: 'N. Central Asia Standard Time' },
  { timeZoneName: 'Asia/Tomsk', timeZoneCode: '', displayName: '(UTC+07:00) Tomsk', id: 'Tomsk Standard Time' },
  { timeZoneName: 'Asia/Hong_Kong', timeZoneCode: '', displayName: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', id: 'China Standard Time' },
  { timeZoneName: 'Asia/Irkutsk', timeZoneCode: '', displayName: '(UTC+08:00) Irkutsk', id: 'North Asia East Standard Time' },
  { timeZoneName: 'Asia/Singapore', timeZoneCode: '', displayName: '(UTC+08:00) Kuala Lumpur, Singapore', id: 'Singapore Standard Time' },
  { timeZoneName: 'Australia/Perth', timeZoneCode: '', displayName: '(UTC+08:00) Perth', id: 'W. Australia Standard Time' },
  { timeZoneName: 'Asia/Taipei', timeZoneCode: '', displayName: '(UTC+08:00) Taipei', id: 'Taipei Standard Time' },
  { timeZoneName: 'Asia/Ulaanbaatar', timeZoneCode: '', displayName: '(UTC+08:00) Ulaanbaatar', id: 'Ulaanbaatar Standard Time' },
  { timeZoneName: 'Australia/Eucla', timeZoneCode: '', displayName: '(UTC+08:45) Eucla', id: 'Aus Central W. Standard Time' },
  { timeZoneName: 'Asia/Chita', timeZoneCode: '', displayName: '(UTC+09:00) Chita', id: 'Transbaikal Standard Time' },
  { timeZoneName: 'Asia/Tokyo', timeZoneCode: '', displayName: '(UTC+09:00) Osaka, Sapporo, Tokyo', id: 'Tokyo Standard Time' },
  { timeZoneName: 'Asia/Pyongyang', timeZoneCode: '', displayName: '(UTC+09:00) Pyongyang', id: 'North Korea Standard Time' },
  { timeZoneName: 'Asia/Seoul', timeZoneCode: '', displayName: '(UTC+09:00) Seoul', id: 'Korea Standard Time' },
  { timeZoneName: 'Asia/Yakutsk', timeZoneCode: '', displayName: '(UTC+09:00) Yakutsk', id: 'Yakutsk Standard Time' },
  { timeZoneName: 'Australia/Adelaide', timeZoneCode: '', displayName: '(UTC+09:30) Adelaide', id: 'Cen. Australia Standard Time' },
  { timeZoneName: 'Australia/Darwin', timeZoneCode: '', displayName: '(UTC+09:30) Darwin', id: 'AUS Central Standard Time' },
  { timeZoneName: 'Australia/Brisbane', timeZoneCode: '', displayName: '(UTC+10:00) Brisbane', id: 'E. Australia Standard Time' },
  { timeZoneName: 'Australia/Melbourne', timeZoneCode: '', displayName: '(UTC+10:00) Canberra, Melbourne, Sydney', id: 'AUS Eastern Standard Time' },
  { timeZoneName: 'Pacific/Guam', timeZoneCode: '', displayName: '(UTC+10:00) Guam, Port Moresby', id: 'West Pacific Standard Time' },
  { timeZoneName: 'Australia/Hobart', timeZoneCode: '', displayName: '(UTC+10:00) Hobart', id: 'Tasmania Standard Time' },
  { timeZoneName: 'Asia/Vladivostok', timeZoneCode: '', displayName: '(UTC+10:00) Vladivostok', id: 'Vladivostok Standard Time' },
  { timeZoneName: 'Australia/Lord_Howe', timeZoneCode: '', displayName: '(UTC+10:30) Lord Howe Island', id: 'Lord Howe Standard Time' },
  { timeZoneName: 'Pacific/Bougainville', timeZoneCode: '', displayName: '(UTC+11:00) Bougainville Island', id: 'Bougainville Standard Time' },
  { timeZoneName: 'Asia/Chokurdakh', timeZoneCode: '', displayName: '(UTC+11:00) Chokurdakh', id: 'Russia Time Zone 10' },
  { timeZoneName: 'Asia/Magadan', timeZoneCode: '', displayName: '(UTC+11:00) Magadan', id: 'Magadan Standard Time' },
  { timeZoneName: 'Pacific/Norfolk', timeZoneCode: '', displayName: '(UTC+11:00) Norfolk Island', id: 'Norfolk Standard Time' },
  { timeZoneName: 'Asia/Sakhalin', timeZoneCode: '', displayName: '(UTC+11:00) Sakhalin', id: 'Sakhalin Standard Time' },
  { timeZoneName: 'Pacific/Guadalcanal', timeZoneCode: '', displayName: '(UTC+11:00) Solomon Is., New Caledonia', id: 'Central Pacific Standard Time' },
  { timeZoneName: 'Asia/Anadyr', timeZoneCode: '', displayName: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', id: 'Russia Time Zone 11' },
  { timeZoneName: 'Pacific/Auckland', timeZoneCode: '', displayName: '(UTC+12:00) Auckland, Wellington', id: 'New Zealand Standard Time' },
  { timeZoneName: 'Pacific/Fiji', timeZoneCode: '', displayName: '(UTC+12:00) Coordinated Universal Time+12', id: 'UTC+12' },
  { timeZoneName: 'Pacific/Fiji', timeZoneCode: '', displayName: '(UTC+12:00) Fiji', id: 'Fiji Standard Time' },
  { timeZoneName: 'Asia/Kamchatka', timeZoneCode: '', displayName: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', id: 'Kamchatka Standard Time' },
  { timeZoneName: 'Pacific/Chatham', timeZoneCode: '', displayName: '(UTC+12:45) Chatham Islands', id: 'Chatham Islands Standard Time' },
  { timeZoneName: 'Pacific/Tongatapu', timeZoneCode: '', displayName: '(UTC+13:00) Coordinated Universal Time+13', id: 'UTC+13' },
  { timeZoneName: 'Pacific/Tongatapu', timeZoneCode: '', displayName: "(UTC+13:00) Nuku'alofa", id: 'Tonga Standard Time' },
  { timeZoneName: 'Pacific/Midway', timeZoneCode: '', displayName: '(UTC+13:00) Samoa', id: 'Samoa Standard Time' },
  { timeZoneName: 'Pacific/Kiritimati', timeZoneCode: '', displayName: '(UTC+14:00) Kiritimati Island', id: 'Line Islands Standard Time' }
]);

export const DEFAULT_ID = {
  id: '00000000-0000-0000-0000-000000000000'
};

export const DOCUMENT_TYPE = {
  cache: 10,

  meetingAgendaItem: 20,
  meetingBoardBook: 21,
  meetingUnified: 22,

  corporateInformation: 30,
  directorsGuide: 31,
  generalBoardInfo: 32,

  alert: 40,

  voting: 50,
  collaboration: 60,

  evaluation: 70,
  evaluationQuestion: 71
};

export const ONEDRIVE_SELECT_MODE = {
  single: 'single',
  multiple: 'multiple'
};

export enum MODULE_TYPE {
  Collaboration = 1,
  Voting = 2,
  Alert = 3,
  Meeting = 4,
  Event = 5,
  InfoSite = 6,
  Evaluation = 7
}

export const PARTIAL_SAVE_MODULE_TYPE = {
  Evaluation: 'Evaluation',
  Survey: 'Survey',
  Voting: 'Voting',
  CustomQueryUserQuestions: 'CustomQueryUserQuestions'
};

export const EXTERNAL_USERS_MODULE_TYPE = {
  Meeting: 'Meeting'
};

export const InAppEventType = {
  MeetingsEvents_BoardBook: 'MeetingsEvents_BoardBook',
  MeetingsEvents_Annotation: 'MeetingsEvents_Annotation',
  MeetingsEvents_AgendaUploaded: 'MeetingsEvents_AgendaUploaded',
  MeetingsEvents_AgendaDeleted: 'MeetingsEvents_AgendaDeleted'
};

export const STREAM_ERROR_MESSAGE = 'Oops! Something went wrong. Please try again after some time. If this issue persists, please contact your administrator.';

export const NO_RELEVANT_INFO_FALLBACK_TEXT = 'could not find any relevant information';

export const ErrorCodes: ErrorCode = {
  500: {
    message: STREAM_ERROR_MESSAGE,
    rerun: false
  },
  10202: {
    message: 'Your summarization is in progress. We will notify you via email once it is ready.',
    rerun: false
  },
  10204: {
    message: "I'm sorry, I could not find any relevant information. Please rephrase your question or contact your administrator.",
    rerun: false
  },
  10400: {
    message: "We're unable to process this request due to safety guidelines. Please rephrase your question.",
    rerun: false
  },
  10403: {
    message: 'Help Bot feature is disabled, please contact your administrator for support.',
    rerun: false
  },
  10429: {
    message: "We're unable to process this request due to a high volume of activity. Please try again shortly.",
    rerun: true
  },
  10500: {
    message: STREAM_ERROR_MESSAGE,
    rerun: false
  },
  10503: {
    message: 'Something went wrong. Please try again.',
    rerun: false
  },
  12330: {
    message: "We're unable to process this request due to safety guidelines. Please rephrase your question.",
    rerun: false
  }
};

export const RESOURCE_TYPES = {
  infoSiteDocument: 'InfoSiteDocument',
  meetingDocument: 'MeetingDocument',
  boardBook: 'BoardBook'
};

export const SUMMARY_TYPES = {
  '1': 'Concise',
  '2': 'Detailed',
  '3': 'Action-oriented',
  '4': 'Custom'
};

export const COMPANY_NAME = 'Computershare Entity Solutions.';
export const PASSWORD_PROTECTED_ERROR_CODE = 'BW102103';
export const PASSWORD_PROTECTED_OFFICEFILES_ERROR_CODE = 'BW102104';
export const PASSWORD_FAIL_ERROR_CODE = 'BWA102103';
export const BROWSER_RESTRICTION_ERROR_CODE = 'BWA102088';

export const SESSION_EXPIRY_MESSAGE = 'Your session has expired. Please close the window.';

export const RESTRICT_BROWSER_ACCESS_MESSAGE =
  'When selected, this user will be restricted from accessing BoardWorks through a web browser. They will be prompted to download and use the mobile app(s) instead.';

export const RESTRICT_BROWSER_ACCESS_MODAL_MESSAGE =
  'When selected, the user(s) below will be restricted from accessing BoardWorks through a web browser. They will be prompted to download and use the mobile app(s) instead.';

export const ANDROID_PACKAGE_NAME = 'com.cgs.bwphone.droid';
export const RESTRICT_BROWSER_ACCESS_INELIGIBLE_MESSAGE = 'Web browser access restrictions are not available for this role.';

export const RESTRICT_BROWSER_ACCESS_ROLE_CHANGE_CONFIRM_MESSAGE =
  'The selected role does not support web browser access restrictions. Saving will remove the web browser restriction for this user. Continue?';

export const RESTRICT_BROWSER_ACCESS_ROLES_INFO_MESSAGE = 'Web browser access restrictions are only supported for certain roles. Selecting a different role may remove this restriction.';
export const AI_CHAT_STATE_KEY = 'ai_chat_window_state';
export const AI_SUMMARY_STATE_KEY = 'ai_summary_window_state';
export const AI_WIDGET_POS_KEY = 'ai-widget-pos';
export const AI_ACTIVE_PANEL = 'ai-active-panel';
export const AI_SAVED_SUMMARY_PARAMS_KEY = 'ai-saved-summary-params';
export const AI_CUSTOM_QUERY_GENERIC_REGEX = /^#{2,}\s*generic\s*/i;
export const AI_CUSTOM_QUERY_ERRORCODE_REGEX = /^#{2,}\s*errorcode\s*\(\s*(\d+)\s*\)\s*/i;
